import { t } from 'i18next'
import styles from './ProgressBar.module.css'

interface ProgressBarProps {
  currentStep: number
  totalSteps: number
}

const ProgressBar = ({ currentStep, totalSteps }: ProgressBarProps) => {
  return (
    <div className={styles.barWrapper}>
      <div className={styles.bar}>
        {/* mb css modules have possibility to use dynamic styles or global variables to avoid creating banch of classes */}
        <span className={`${styles.sign} ${styles[`left-${currentStep}`]}`}>
          {currentStep} {t('onboarding.of')} {totalSteps}
        </span>
      </div>
    </div>
  )
}

export default ProgressBar
